import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@v2/shared/lib/utils';

export type AlertColor = 'danger' | 'success' | 'info' | 'warning' | 'default';

type Props = ComponentPropsWithoutRef<'div'> & {
  color?: AlertColor;
};

/**
 * Colours are the semantic four plus a neutral. The legacy Alert this replaces also
 * accepted 'red'/'green'/'blue'/'yellow'/'gray' as aliases for the same five; nothing
 * used them, so they are not carried over.
 */
const colorClasses: Record<AlertColor, string> = {
  danger: 'bg-red-50 text-red-900 border-red-400',
  success: 'bg-green-50 text-green-900 border-green-200',
  info: 'bg-blue-50 text-blue-900 border-blue-200',
  warning: 'bg-yellow-50 text-yellow-800 border-yellow-300',
  default: 'bg-slate-50 text-slate-600 border-slate-200',
};

export default function Alert({ color = 'default', className, children, ...rest }: Props) {
  return (
    <div
      role={color === 'danger' ? 'alert' : undefined}
      className={cn('p-3 border-2 border-solid rounded mb-5', colorClasses[color], className)}
      {...rest}
    >
      {children}
    </div>
  );
}
